module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('button', {
    staticClass: "sp-button-sm",
    attrs: {
      "id": "myBtn",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openModal('setShopTogetherModal')
      }
    }
  }, [_vm._v("Share on Shop Together")])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    staticStyle: {
      "top": "5em",
      "padding": "1em",
      "width": "97%"
    },
    attrs: {
      "id": "setShopTogetherModal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.closeModal('setShopTogetherModal')
      }
    }
  }, [_c('span', {
    staticClass: "close"
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    key: _vm.shopTogetherAlertKey,
    staticClass: "card"
  }, [_c('h5', {
    staticStyle: {
      "color": "#ff5566",
      "padding-left": "0.7em"
    }
  }, [_vm._v("Share with")]), _vm._v(" "), _vm._l((_vm.shop_together_activities), function(shp, shpindex) {
    return _c('div', {
      key: shpindex,
      staticClass: "card card-flat-pad"
    }, [_c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [((shp.data_shared && (shp.data_shared != ''))) ? _c('p', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(shp.data_shared))]) : _c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "background": "#fc4112 !important",
        "color": "#ffffff !important"
      },
      attrs: {
        "id": "myBtn",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showShareOnShopTogether('S2G' + shpindex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-share-alt"
    }), _vm._v(" Share")])]), _vm._v(" "), _c('ul', {
      staticStyle: {
        "clear": "both"
      }
    }, _vm._l((shp.activity_users), function(u, uindex) {
      return _c('li', {
        key: uindex,
        staticStyle: {
          "display": "inline-block",
          "margin-left": "1em",
          "text-align": "center"
        }
      }, [_vm._m(0, true), _vm._v(" "), _c('span', {
        staticClass: "sp-app-default-color",
        staticStyle: {
          "font-size": "12px"
        }
      }, [(_vm.user.user_id == u.activity_user) ? _c('span', [_vm._v("You")]) : _c('span', [_vm._v(_vm._s(u.activity_user_fullname))])])])
    })), _vm._v(" "), _c('ul', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'S2G' + shpindex
      }
    }, [_c('li', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shp.data_caption),
        expression: "shp.data_caption"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Say something about this"
      },
      domProps: {
        "value": (shp.data_caption)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          shp.data_caption = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "background": "#fc4112 !important",
        "color": "#ffffff !important"
      },
      attrs: {
        "id": "myBtn",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.shareOnShopTogether(shp, shpindex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-share-alt"
    })])])])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "width": "30",
      "height": "30"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aa61d0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/activeshoptogether.vue
// module id = 514
// module chunks = 0